<template>
  <b-container class="p-0" :class="{ 'box-bordered': !noBorder, 'p-3': !noBorder }">
    <div v-if="title" class="font-weight-bold" :class="{ 'mb-3': noSeparator }">{{ title }}</div>
    <hr v-if="title && !noSeparator" />
    <slot></slot>
  </b-container>
</template>

<script>
export default {
  props: {
    title: String,
    noBorder: Boolean,
    noSeparator: Boolean,
  },
}
</script>

<style lang="scss" scoped>
.box-bordered {
  border: 1px solid var(--gray8);
  border-radius: 0.5rem;
}
</style>
